import { render, staticRenderFns } from "./userMGT-complaint-list.vue?vue&type=template&id=019e5e30&scoped=true&"
import script from "./userMGT-complaint-list.vue?vue&type=script&lang=js&"
export * from "./userMGT-complaint-list.vue?vue&type=script&lang=js&"
import style0 from "./userMGT-complaint-list.vue?vue&type=style&index=0&id=019e5e30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e5e30",
  null
  
)

export default component.exports